import { Flex } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';
import { Paragraph } from '../../atoms';

type Props = PropsWithChildren<{
  label?: string;
}>;

export function Container({ label, children }: Props): ReactNode {
  return (
    <Flex flexDirection="column" justify="space-between" h="full">
      {label ? (
        <Paragraph mb="4px" fontSize="sm" fontWeight="400" color="#6A6E77">
          {label}
        </Paragraph>
      ) : null}
      {children}
    </Flex>
  );
}
